import React from 'react'

import RemoveOrDeleteRow from '@front/squirtle/components/FormTable/Actions/RemoveOrDeleteRow'

const ButtonComponent = (props) => <RemoveOrDeleteRow {...props} />

export default React.memo(ButtonComponent)
